angular.module('app').factory('UserAdminService', ($http, ApiErrorService) => {
    return {
        passwordRules: passwordRules,
        allUsers: allUsers,
        singleUser: singleUser,
        saveUser: saveUser,
        resetPassword: resetPassword,
        deleteUser: deleteUser,
        lockoutUser: lockoutUser,
        hardDeleteUser: hardDeleteUser,
        users: users,
        filterUsers: filterUsers
    };
    function passwordRules() {
        return $http.get(['api/UsersAdmin/PasswordRules'].join(''));
    }
    function allUsers() {
        return $http.get(['api/UsersAdmin/Users'].join(''));
    }
    function saveUser(user) {
        return $http.post(['api/UsersAdmin/SaveUser'].join(''), user);
    }
    function resetPassword(userId, password) {
        return $http.post(['api/UsersAdmin/ResetPassword'].join(''), {
            UserId: userId,
            Password: password
        });
    }
    function deleteUser(id, isDeleted) {
        return $http.post(['api/UsersAdmin/DeleteUser'].join(''), {
            id: id,
            isDeleted: isDeleted
        });
    }
    function lockoutUser(id, isLocked) {
        return $http.post(['api/UsersAdmin/LockUser'].join(''), {
            UserId: id,
            IsLocked: isLocked
        });
    }
    function hardDeleteUser(userId) {
        return $http.post(['api/UsersAdmin/HardDeleteUser?userId=', userId].join(''), {});
    }
    function singleUser(userId) {
        return $http.get(['api/UsersAdmin/SingleUser?userId=', userId].join(''));
    }
    function users(users) {
        let usersList = _.map(users, function (item) {
            return {
                Id: item.Id,
                Name: item.Description
            };
        });
        // @ts-ignore : missing from the lodash typing
        let uniqueUsers = _.uniqBy(usersList, function (item) {
            return item.Id;
        });
        if (uniqueUsers.length === 0) {
            let response = [];
            response[0] = { Id: 0, Name: 'No users available' };
            return response;
        }
        // return _.sortBy(uniqueUsers, ['Name']);
        return _.sortBy(uniqueUsers, ['Name'.toLowerCase()]);
        // var sorted = _.sortBy(uniqueUsers, ['Name']);
        // var all = { Id: 0, Name: 'All Users' };
        // return _.concat(all, sorted);
    }
    function filterUsers(Users, testerId) {
        let testerSimRows = _.filter(Users, function (item) {
            // @ts-ignore lodash
            if (testerId === 0 || _.isNil(testerId)) {
                return Users;
            }
            return item.Id === testerId;
        });
        return _.sortBy(testerSimRows, ['Description']);
    }
});
